import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_SALE_ACTIVITY:
    case actions.CREATE_SALE_ACTIVITY_CATEGORY:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_SALE_ACTIVITY_ENDED:
    case actions.CREATE_SALE_ACTIVITY_CATEGORY_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.DELETE_SALE_ACTIVITIES:
    case actions.DELETE_SALE_ACTIVITY_CATEGORIES:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_SALE_ACTIVITIES_ENDED:
    case actions.DELETE_SALE_ACTIVITY_CATEGORIES_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    case actions.UPDATE_SALE_ACTIVITY:
    case actions.UPDATE_SALE_ACTIVITY_CATEGORY:
    case actions.UPDATE_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION:
    case actions.UPDATE_SALE_ACTIVITY_RECEIPT_CONFIGURATION:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_SALE_ACTIVITY_ENDED:
    case actions.UPDATE_SALE_ACTIVITY_CATEGORY_ENDED:
    case actions.UPDATE_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION_ENDED:
    case actions.UPDATE_SALE_ACTIVITY_RECEIPT_CONFIGURATION_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.SEARCH_SALE_ACTIVITIES:
    case actions.FIND_SALE_ACTIVITY_CATEGORY:
    case actions.FIND_SALE_ACTIVITY:
    case actions.SEARCH_SALE_ACTIVITY_CATEGORIES:
    case actions.GET_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION:
    case actions.GET_SALE_ACTIVITY_RECEIPT_CONFIGURATION:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_SALE_ACTIVITIES_ENDED:
    case actions.FIND_SALE_ACTIVITY_CATEGORY_ENDED:
    case actions.FIND_SALE_ACTIVITY_ENDED:
    case actions.SEARCH_SALE_ACTIVITY_CATEGORIES_ENDED:
    case actions.GET_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION_ENDED:
    case actions.GET_SALE_ACTIVITY_RECEIPT_CONFIGURATION_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    default:
      return state;
  }
}
